import styled from 'styled-components'

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10002;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const ModalContainer = styled.div`
  background: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.background?.modal || '34, 34, 34'})` : '#ffffff'};
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
  padding: 2em;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);
  position: relative;
  animation: slideUp 0.3s ease;

  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    padding: 1.5em;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['400'] || '74, 74, 74'})` : '#999'};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.isDark ? `rgb(${theme.background?.high || '13, 13, 13'})` : '#f0f0f0'};
    color: ${({ theme }) =>
      theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  margin-bottom: 0.5em;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['100'] || '249, 249, 249'})` : '#111'};

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`

export const ModalSubtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) =>
    theme.isDark ? `rgb(${theme.grayscale?.['200'] || '74, 74, 74'})` : '#666'};
  margin: 0;
  margin-bottom: 2em;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`

export const ActionButton = styled.button<{ variant: 'primary' | 'secondary' }>`
  flex: 1;
  padding: 1em 1.5em;
  border-radius: 12px;
  border: none;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  ${({ variant, theme }) =>
    variant === 'primary'
      ? `
    background: rgb(${theme.primary?.base || '255, 133, 51'});
    color: rgb(${theme.grayscale?.['100'] || '249, 249, 249'});
    
    &:hover {
      background: rgb(${theme.primary?.['500'] || '255, 163, 102'});
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(255, 133, 51, 0.3);
    }
  `
      : `
    background: transparent;
    color: rgb(${theme.grayscale?.['200'] || '207, 207, 207'});
    border: 2px solid rgb(${theme.background?.high || '13, 13, 13'});
    
    &:hover {
      background: rgb(${theme.background?.high || '13, 13, 13'});
      color: rgb(${theme.grayscale?.['100'] || '249, 249, 249'});
    }
  `}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 768px) {
    padding: 0.9em 1.2em;
    font-size: 0.9rem;
  }
`
